export const PDF_COLORS = {
  // Brand colors
  PRIMARY: '#000000',
  ACCENT: '#00C369',
  GECKO_ORANGE: '#FF4000',

  // Text colors
  TEXT_PRIMARY: '#000000',
  TEXT_SECONDARY: '#333333',
  TEXT_TERTIARY: '#666666',
  TEXT_LIGHT: '#FFFFFF',
  TEXT_MUTED: '#999999',

  // UI colors
  BACKGROUND_LIGHT: '#FFFFFF',
  BACKGROUND_OFF_WHITE: '#EEEEEE',
  BACKGROUND_LIGHT_GRAY: '#CCCCCC',
  BACKGROUND_GRAY: '#999999',

  // Border colors
  BORDER_LIGHT: '#CCCCCC',
  BORDER_MEDIUM: '#999999',

  // Status colors
  ERROR: '#C0392B',
  SUCCESS: '#00C369',

  // Gradient colors (used in stripe)
  GRADIENT_START: '#FF4000',
  GRADIENT_MID_1: '#FFDD00',
  GRADIENT_MID_2: '#69FF42',
  GRADIENT_MID_3: '#00C369',
  GRADIENT_END: '#009EFF',
}
